import main from './main';
import product from './product';
import recipe from './recipe';
import occasion from './occasion';
import post from './post';
import faq from './faq';
import landingPageRecipes from './landing-page-recipes';

const init = () => {
    main();
    product();
    recipe();
    occasion();
    post();
    faq();
    landingPageRecipes();
};

export default init;
